import axios from '@/plugin/axios';

const urlNewAdmin = '/admins/';

/**
 * Register new admin
 * @param {object} details
 * @returns {Promise<object>}
 */
const RegisterAdmin = (details) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .post(urlNewAdmin, details)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Retrieve Admins
 * @returns {Promise<object>}
 */
const getAdmin = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`/admins/`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Update an Admin
 * @param {object} updateData
 * @returns {Promise<object>}
 */
const updateAdmin = (updateData) =>
  new Promise((resolve, reject) => {
    const { id, data } = updateData;
    axios
      .patch(`/admins/${id}/`, data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Retrieve an Admin by id
 * @param {string|number} id
 * @returns {Promise<object>}
 */
const getAdminById = (id) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .get(`/admins/${id}/`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Approve Dataset
 * @param {string|number} id
 * @returns {Promise<object>}
 */
const approveDataset = (id) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .get(`/datasets/${id}/approve/`)
      .then((response) => {
        resolve(response);
        this.$swal('Hello word!');
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Reject Dataset
 * @param {string|number} id
 * @returns {Promise<object>}
 */
const rejectDataset = (id) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .get(`/datasets/${id}/reject/`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Approve Project
 * @param {string|number} id
 * @returns {Promise<object>}
 */
const approveProject = (id) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .get(`/projects/${id}/approve/`)
      .then((response) => {
        resolve(response);
        this.$swal('Hello word!');
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Reject Project
 * @param {string|number} id
 * @returns {Promise<object>}
 */
const rejectProject = (id) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .get(`/projects/${id}/reject/`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Approve NGO
 * @param {string|number} id
 * @returns {Promise<object>}
 */
const approveNgo = (id) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .get(`/organizations/${id}/approve/`)
      .then((response) => {
        resolve(response);
        this.$swal('Hello word!');
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Reject NGO
 * @param {string|number} id
 * @returns {Promise<object>}
 */
const rejectNgo = (id) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .get(`/organizations/${id}/reject/`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

/**
 * Update NGO
 * @param {{id: string|number, data: object}} updateData
 * @returns {Promise<object>}
 */
const updateNgo = (updateData) =>
  new Promise((resolve, reject) => {
    const { id, data } = updateData;
    axios
      .patch(`/organizations/${id}/`, data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

//= ========================Get DataSets==================================//
const getDatasets = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`/datasets/`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

//= ========================Get Activities==================================//
const getActivities = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`/activities/`, { params: { ordering: '-created_at' } })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

//= ========================Get DataSet by Id==================================//
const getDatasetById = (id) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .get(`/datasets/${id}/`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

//= ========================Update DataSet==================================//
const updateDataset = (updateData) =>
  new Promise((resolve, reject) => {
    const { id, data } = updateData;
    axios
      .patch(`/datasets/${id}/`, data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

//= ========================Post DataSets==================================//
const postDatasets = (details) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .post('/datasets/', details)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

//= ========================Get DataRequest==================================//
const getDatarequests = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`/datarequests/`)
      .then((response) => {
        console.log(response, 'respose');
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

//= ========================Get Datarequestby Id==================================//
const getDatarequestById = (id) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .get(`/datarequests/${id}/`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

//= ========================Update Datarequest==================================//
const updateDatarequests = (updateData) =>
  new Promise((resolve, reject) => {
    const { id, data } = updateData;
    axios
      .patch(`/datarequests/${id}/`, data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });

//= ========================Post Datarequest==================================//
const postDatarequest = (details) =>
  new Promise((resolve, reject) => {
    // alert(LoginDetails.type)
    // console.log(user);
    axios
      .post('/datarequests/', details)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // processError(error);
        reject(error);
      });
  });
export default {
  RegisterAdmin,
  getAdmin,
  updateAdmin,
  disableAdmin: (id) => axios.post(`/admins/${encodeURIComponent(id)}/disable/`),
  enableAdmin: (id) => axios.post(`/admins/${encodeURIComponent(id)}/enable/`),
  deleteAdmin: (id) => axios.delete(`/admins/${encodeURIComponent(id)}/`),
  approveDataset,
  rejectDataset,
  getAdminById,
  approveProject,
  rejectProject,
  approveNgo,
  rejectNgo,
  updateNgo,
  getDatasets,
  getDatasetById,
  updateDataset,
  postDatasets,
  getDatarequestById,
  getDatarequests,

  updateDatarequests,
  postDatarequest,
  getActivities,
};
